import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { isPaymentBlockedByUserCountryCookie } from '../utils/userCountryCookie'

/**
 * Uses nginx `user_country` cookie (from CF) so client-side React Router navigations
 * to /pay or /payment still redirect without a new full page load.
 */
export function paymentGeoLoader({ request }: LoaderFunctionArgs) {
  const pathname = new URL(request.url).pathname
  if (pathname !== '/pay' && pathname !== '/payment') return null
  if (isPaymentBlockedByUserCountryCookie()) {
    return redirect('/payment-blocked')
  }
  return null
}
